export default "__VITE_ASSET__DgG22e6d__"